module.exports = __webpack_public_path__ + "img/logo-homedoctor-color.7c37da37.png";